import React from "react";
import audienceNextArrow from "../../assets/images/webp/other/audience-next-arrow.webp";
import { COLLABORATE_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";

const Callaborate = () => {
  return (
    <div className="">
      <div className="px-4 bg-[#EAF3EE] xl:pb-80 pb-60">
        <div className="pt-[100px] max-lg:pt-20 max-md:pt-14 max-sm:pt-10">
          <div className="flex items-center justify-center flex-col">
            <BlueTag center>Collaborate</BlueTag>
            <Heading className=" mb-[50px] max-lg:mb-10 max-sm:mb-5 text-center">
              Want to Learn More or Collaborate?
            </Heading>
          </div>
          <div className="max-w-[1140px] w-full mx-auto h-[426px] flex flex-wrap max-lg:justify-center max-lg:h-full max-lg:!gap-6 relative mt-[50px] transition-all ease-linear duration-300 hover:scale-100">
            <img
              src={audienceNextArrow}
              alt="arrow"
              width={272}
              height={83}
              className="absolute top-[-74px] left-[18%] z-10 max-lg:hidden"
            />
            <img
              src={audienceNextArrow}
              alt="arrow"
              width={272}
              height={83}
              className="absolute top-[-24px] right-[18%] z-10 max-lg:hidden"
            />
            {COLLABORATE_LIST.map((obj, i) => (
              <div
                key={i}
                className={`projects-box-bg lg:hidden w-full max-w-[364px] max-xl:max-w-[300px] p-[1px] h-[241px] flex items-center justify-center flex-col shadow-[0px_4px_17.7px_0px_#0000001A] rounded-2xl `}>
                <div className="w-full bg-white h-full flex items-center justify-center flex-col rounded-2xl">
                  <Icons icon={obj.icon} />
                  <h3 className="text-[#001A3D] leading-[130%] text-[28px] text-center mx-auto max-w-[324px] ff-jakarta font-bold max-md:text-2xl max-sm:text-xl">
                    {obj.name}
                  </h3>
                </div>
              </div>
            ))}
            {COLLABORATE_LIST.map((obj, i) => (
              <div
                key={i}
                className={`projects-box-bg max-lg:hidden w-full max-w-[364px] max-xl:max-w-[300px] p-[1px] h-[241px] flex items-center justify-center flex-col shadow-[0px_4px_17.7px_0px_#0000001A] rounded-2xl absolute ${
                  i === 0
                    ? "top-0 left-0"
                    : i === 1
                    ? "top-[42%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                    : i === 2
                    ? "bottom-[20%] right-0"
                    : ""
                }`}>
                <div className="w-full bg-white h-full flex items-center justify-center flex-col rounded-2xl">
                  <p>{obj.icon}</p>
                  <h3 className="text-[#001A3D] leading-[130%] text-[28px] text-center mx-auto max-w-[324px] ff-jakarta font-bold max-md:text-2xl max-sm:text-xl">
                    {obj.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Callaborate;
